import { Component,Renderer2 } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from 'src/assets/icons/icon-subset';
import { Title } from '@angular/platform-browser';
import { environment} from 'src/environments/environment';
import {TranslateService} from '@ngx-translate/core';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Dhabi Admin Portal';

  constructor(
    private router: Router,
    private titleService: Title,
    private iconSetService: IconSetService,
    private translate: TranslateService,
    private renderer: Renderer2
  )
  {
    
    console.log('Running version ' + environment.version + ', production environment is ' + environment.production)

    titleService.setTitle(this.title);
    iconSetService.icons = { ...iconSubset };

    // this language will be used as a fallback when a translation isn't found in the current language
    // translate.setDefaultLang('en');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    // translate.use('en');
    translate.setDefaultLang('en');
    let lang = sessionStorage.getItem('lang') || 'en';
    translate.use(lang);
    document.documentElement.lang = lang;
    if (lang == 'ar')
      this.renderer.setAttribute(document.body, 'dir', 'rtl');
    else
      this.renderer.setAttribute(document.body, 'dir', 'ltr');
  }
  }

